import { render, staticRenderFns } from "./Questionmark.vue?vue&type=template&id=a0d87400&scoped=true&"
import script from "./Questionmark.vue?vue&type=script&lang=js&"
export * from "./Questionmark.vue?vue&type=script&lang=js&"
import style0 from "./Questionmark.vue?vue&type=style&index=0&id=a0d87400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d87400",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
